import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login/index'
import orderHistoryExport from '@/components/orderHistoryExport'
import lookFile from '@/components/assembly/lookFile'
var notfount = () => import('@/components/notfount')

// 解决同个路由重复点击报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const VueRouterReplace = Router.prototype.replace
Router.prototype.replace = function replace (to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/lookFile',
    name: '/lookFile',
    component: lookFile,
    meta: {
      isLogin: false,
      title: '查看附件',
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      keepAlive: true,
      title: '新媒体事业部消耗表系统',
    }
  },
  {
    path: '/orderHistoryExport',
    name: 'orderHistoryExport',
    component: orderHistoryExport,
    meta: {
      isLogin: false,
      keepAlive: true,
      title: '新媒体事业部消耗表系统',
    }
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import('@/components/demo'),
    meta: {
      isLogin: false,
      keepAlive: true,
      title: '新媒体事业部消耗表系统',
    }
  },
  {
    path: "*",
    name: 'notfount',
    component: notfount,
    meta: {
      isLogin: true,
      title: '404'
    }
  },
]

const createRouter = () => new Router({
  // mode: 'history',
  // base: '/financeFormSystem/',
  routes: constantRoutes,
})
const router = createRouter()

//写一个重置路由的方法，切换用户后，或者退出时清除动态加载的路由
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // 新路由实例matcer，赋值给旧路由实例的matcher，（相当于replaceRouter）
}

/* 路由异常错误处理，尝试解析一个异步组件时发生错误，重新渲染目标页面 */
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    // router.replace(targetPath);
    router.go(0)
  }
});

export default router


// WEBPACK FOOTER //
// ./src/router/index.js